import { availabilityStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAvailability";
import { GridOffset } from "@insite/mobius/GridContainer";
import { css } from "styled-components";

/*

**** EC-231 Product Details Page (PDP) ****

*** Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments. */
availabilityStyles.availability = {
    container: {
        css: css`
            ${GridOffset} {
                width: 100%;
                display: flex;
                /* EC-879 : Moving "View availability by branch" link below stock indicator */
                flex-direction: column;
                gap: 10px;
            }
        `,
    },
    availabilityByWarehouseLinkGridItem: {
        css: css`
            display: flex;
            justify-content: start;
        `,
    },
};

/* *** End: Dynamic CSS refactoring complete. Apply future updates here instead of the CMS. */
